import React from "react";
import { PageHeaderWrapper } from "@ant-design/pro-layout";
import { Card } from "antd";
import ShipmentForm from "@/forms/shared/Shipment";
const EditShipment = () => (React.createElement(PageHeaderWrapper, { onBack: () => window.history.back() },
    React.createElement(Card, { bordered: false },
        React.createElement(ShipmentForm, null))));
export default EditShipment;
